/**
 * PUTs a file to a presigned S3 upload URL, per SIA's Object Lock requirements (see
 * DocumentsS3Service): the checksum header must match what was signed into the URL, and
 * If-None-Match: * enforces the object doesn't already exist.
 */
const putDocumentToS3 = (uploadUrl: string, file: File, contentType: string, contentSha256: string) =>
  fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
      'x-amz-checksum-sha256': contentSha256,
      'If-None-Match': '*',
    },
  });

export default putDocumentToS3;
